import { useQuery } from "@tanstack/react-query";
import { endpoints } from "@/lib/api";
import ClockWeather from "@/components/ClockWeather";
import CalendarPanel from "@/components/CalendarPanel";
import TodoPanel from "@/components/TodoPanel";
import GroceryPanel from "@/components/GroceryPanel";
import NotepadPanel from "@/components/NotepadPanel";
import VoiceButton from "@/components/VoiceButton";
import TouchKeyboard from "@/components/TouchKeyboard";
import Slideshow from "@/components/Slideshow";

export default function Dashboard() {
  const { data: family = [] } = useQuery({
    queryKey: ["family"],
    queryFn: endpoints.family,
  });

  return (
    <div
      data-testid="dashboard-root"
      className="h-screen w-screen overflow-hidden p-4 md:p-6 flex gap-4 md:gap-6"
      style={{ backgroundColor: "#1f3528" }}
    >
      {/* Left column: Clock+Weather (top) and Calendar (bottom) */}
      <div className="w-5/12 flex flex-col gap-4 md:gap-6 h-full min-w-0">
        <ClockWeather />
        <CalendarPanel family={family} />
      </div>

      {/* Middle column: Todos */}
      <div className="w-4/12 h-full min-w-0">
        <TodoPanel family={family} />
      </div>

      {/* Right column: Grocery (top) and Notes (bottom) */}
      <div className="w-3/12 flex flex-col gap-4 md:gap-6 h-full min-w-0">
        <GroceryPanel />
        <NotepadPanel />
      </div>

      <VoiceButton />
      <TouchKeyboard />
      <Slideshow />
    </div>
  );
}
